export { AppActivity } from './activityApp/activity';
export { MyActivity } from './myactivity/page';
export { Employee } from './employee/page';
export { IdleStaff } from './idle/page';
export { Tracking } from './tracking/page';
export { MarkerPage } from './marker/marker';
export { TrackingWeb } from './tracking_web/page';

// Page crud
export { AddActivity } from './add_activity/page';
export { DetailEmployeeActivity } from './employee/detail/page';
export { DetailActivity } from './myactivity/detail/page';
export { DetailIdle } from './idle/detail/page';
export { DetailTrackingActivity } from './tracking/detail/page';
export { HistoryTracking } from './tracking/history/page';
export { UbahActivity } from './myactivity/ubah/page';



// WEBPACK FOOTER //
// ./src/pages/activity/index.ts